const forgotPassword = {
  forgotYourPassword: '¿Olvidó su contraseña?',
  backToLogin: 'Continuar para iniciar sesión',
  sendResetLink: 'Enviar enlace de restablecimiento',
  emailHint: 'La dirección de correo electrónico que recibió de su administrador',
  noWorries: '¡No se preocupes! Introduzca su correo electrónico y le enviaremos un enlace para restablecer su contraseña.',
  PleaseEnterEmailAddress: 'Introduzca su dirección de correo electrónico',
  thankYou: '¡Gracias!',
  forgotPassword: 'Olvidó la contraseña',
  successHint: 'Si el correo electrónico que ha ingresado existe en nuestro sistema, le enviaremos un enlace para restablecer su contraseña en unos segundos',
  emailAddress: 'Dirección de correo electrónico',
  redirect: 'Será redirigido a ',
  seconds: ' segundos',
  emailRequires: 'El correo electrónico es obligatorio',
  invalidEmail: 'El correo electrónico no es válido',
};

export default forgotPassword;
